/** সাহায্য কেন্দ্র ও বিটা ফিডব্যাক (docs/specs/beta.md, B-69)। */
export const help = {
    title: "সাহায্য",
    description: "প্রতিদিনের কাজের ছোট গাইড, আর Sobthik টিমের সাথে সরাসরি যোগাযোগ।",
    guides: "গাইড",
    steps: "ধাপ",
    contactTitle: "এখনো আটকে আছেন?",
    contactBody: "উপরে ডানে ফিডব্যাক দিয়ে আমাদের লিখুন। বিটা চলাকালীন আমরা এক কর্মদিবসের মধ্যে উত্তর দিই।",
    articles: {
        start: {
            title: "ব্যবসা সেটআপ করুন",
            summary: "ব্যবসার তথ্য, প্রথম শাখা ও কর্মী — প্রায় ১০ মিনিট।",
            s1: "সেটিংস → ব্যবসা: লোগো, ঠিকানা ও BIN (থাকলে) দিন।",
            s2: "সেটিংস → লোকেশন: প্রথম শাখাটি দেখুন; আরও শাখা বা গুদাম যোগ করুন।",
            s3: "সেটিংস → কর্মী: প্রত্যেককে মোবাইল নম্বর, প্রথম পাসওয়ার্ড ও রোল (ক্যাশিয়ার, শাখা ম্যানেজার…) দিয়ে যোগ করুন। প্রথম সাইন-ইনে তারা নিজের পাসওয়ার্ড দেবেন।",
            s4: "সেটিংস → নিরাপত্তা: নিজের জন্য দুই-ধাপ সাইন-ইন চালু করুন।",
            s5: "ড্যাশবোর্ডের চেকলিস্ট অনুসরণ করুন — যেকোনো ধাপ বাদ দিয়ে পরে করা যায়।",
        },
        products: {
            title: "পণ্য যোগ করুন",
            summary: "একটি একটি করে, স্প্রেডশিট থেকে, অথবা নমুনা পণ্য দিয়ে শুরু করুন।",
            s1: "ক্যাটালগ → পণ্য → নতুন পণ্য: নাম (ইংরেজি ও বাংলা), একক, দাম ও খরচ।",
            s2: "একাধিক সাইজ বা রং? অপশন যোগ করুন; প্রতিটি মিলে আলাদা দাম ও স্টকসহ একটি ভ্যারিয়েন্ট হয়।",
            s3: "অনেক পণ্য: ক্যাটালগ → ইমপোর্ট → টেমপ্লেট ডাউনলোড করুন, Excel-এ পূরণ করে আপলোড করুন।",
            s4: "পণ্য থেকে বা মাল গ্রহণ থেকে বারকোড লেবেল প্রিন্ট করুন।",
            s5: "ইনভেন্টরি → স্টক সমন্বয় দিয়ে আজ তাকে যা আছে তা লিখুন।",
        },
        pos: {
            title: "POS যুক্ত করুন ও প্রথম বিক্রি করুন",
            summary: "দোকানের কম্পিউটারে POS অ্যাপ ইনস্টল করে বিক্রি করুন — ইন্টারনেট ছাড়াও।",
            s1: "কাউন্টারের কম্পিউটারে Sobthik POS ইনস্টল করুন।",
            s2: "অ্যাডমিন → POS → ডিভাইস → রেজিস্টার যুক্ত করুন: পেয়ারিং কোডটি POS-এ লিখুন।",
            s3: "ড্রয়ারের নগদ দিয়ে শিফট খুলুন, পণ্য স্ক্যান বা খুঁজুন, পেমেন্ট নিন।",
            s4: "ইন্টারনেট নেই? বিক্রি চালিয়ে যান। বিল কম্পিউটারে থাকে এবং পরে নিজে থেকেই সিঙ্ক হয়।",
            s5: "দিন শেষে: শিফট বন্ধ করে নগদ গুনুন; Z রিপোর্টে দিনের হিসাব দেখা যায়।",
        },
        orders: {
            title: "অনলাইন অর্ডার ও কুরিয়ার",
            summary: "ফোন, ফেসবুক ও হোয়াটসঅ্যাপের অর্ডার, আপনার কুরিয়ারে ডেলিভারি।",
            s1: "সেটিংস → কুরিয়ার: আপনার Pathao, Steadfast বা RedX অ্যাকাউন্ট যুক্ত করুন।",
            s2: "অর্ডার → নতুন অর্ডার: গ্রাহকের ফোন, ঠিকানা ও পণ্য। অর্ডারের জন্য স্টক আলাদা রাখা হয়।",
            s3: "অর্ডার কনফার্ম করে কুরিয়ার বুক করুন: কনসাইনমেন্ট নম্বর অর্ডারে সংরক্ষিত হয়।",
            s4: "কুরিয়ারের আপডেট (পিকআপ, ডেলিভারি, ফেরত) নিজে থেকেই অর্ডারে দেখা যায়।",
            s5: "ক্যাশ অন ডেলিভারি: পেমেন্ট → কুরিয়ার পেআউট দিয়ে কুরিয়ার যা দিয়েছে তা মিলান।",
        },
        offline: {
            title: "ইন্টারনেট না থাকলে",
            summary: "কী চালু থাকে, আর ফিরে এলে কী দেখবেন।",
            s1: "ইন্টারনেট ছাড়াই POS দিনের পর দিন বিক্রি, রসিদ প্রিন্ট ও ফেরত নিতে পারে।",
            s2: "স্ট্যাটাস বারে কতটি বিল সিঙ্কের অপেক্ষায় তা দেখা যায়।",
            s3: "বিল অপেক্ষায় থাকলে POS আনইনস্টল বা কম্পিউটার রিসেট করবেন না।",
            s4: "ইন্টারনেট ফিরলে এক মিনিটের মধ্যে বিল সিঙ্ক হয়; কিছুই দুবার যায় না।",
            s5: "POS → রিভিউ-তে সার্ভার যে বিল ম্যানেজারকে দেখাতে চায় তা থাকে (যেমন স্টকের পার্থক্য)।",
        },
        reports: {
            title: "রিপোর্ট ও দিন শেষ",
            summary: "বিক্রি, লাভ, স্টক ও নগদ — এবং কীভাবে এক্সপোর্ট করবেন।",
            s1: "ড্যাশবোর্ড: আজকের বিক্রি, লাভ ও যা করতে হবে।",
            s2: "রিপোর্ট: যেকোনো তারিখের পণ্য, শাখা, চ্যানেল ও পেমেন্ট পদ্ধতি অনুযায়ী বিক্রি।",
            s3: "যেকোনো রিপোর্ট Excel বা PDF-এ এক্সপোর্ট করুন (দুটোতেই বাংলা ঠিক থাকে)।",
            s4: "হিসাব: প্রতিটি শাখার ক্যাশবুক ও প্রতিটি পেমেন্ট অ্যাকাউন্টের ব্যালান্স।",
            s5: "সেটিংস → ডেটা ও অ্যাকাউন্ট: যেকোনো সময় সব ডেটা ডাউনলোড করুন।",
        },
    },
    feedback: {
        button: "ফিডব্যাক",
        title: "ফিডব্যাক পাঠান",
        description: "কী ভুল হয়েছে, কী হলে সুবিধা হয়, অথবা প্রশ্ন করুন। আমরা প্রতিটি বার্তা পড়ি।",
        kind: "বিষয়",
        kinds: { bug: "কিছু ভুল হচ্ছে", idea: "একটি আইডিয়া", question: "একটি প্রশ্ন" },
        message: "আপনার বার্তা",
        messageHint: "কী করেছিলেন, কী হলো, কী আশা করেছিলেন? (কমপক্ষে ৫ অক্ষর)",
        page: "{{page}} থেকে পাঠানো",
        send: "পাঠান",
        sent: "ধন্যবাদ — আমরা পেয়েছি।",
        mine: "আপনার ফিডব্যাক",
        empty: "আপনি এখনো ফিডব্যাক পাঠাননি।",
        answer: "Sobthik: {{answer}}",
        statuses: {
            new: "পাওয়া গেছে",
            triaged: "দেখা হয়েছে",
            planned: "পরিকল্পনায়",
            fixed: "ঠিক করা হয়েছে",
            wont_fix: "পরিকল্পনায় নেই",
        },
    },
};
//# sourceMappingURL=help.js.map